/**
 * Poll intervals (ms) for the Hub's React Query refetches. Chat is the most
 * latency-sensitive; the rest tolerate a slower cadence since the underlying
 * reads hit the (replica-lagged) read pool.
 */
export const HUB_POLL_INTERVALS_MS = {
  conversationItems: 4_000,
  customerCalls: 15_000,
  customerDetail: 15_000,
  customerNotes: 15_000,
  customersList: 15_000,
  folderCounts: 30_000,
  liveTransferCount: 10_000,
  liveTransfers: 15_000,
} as const;

/**
 * Poll interval for surfaces the realtime socket keeps fresh, used only while it is connected.
 * Bounds how late a write that never calls publishHubEvents shows up.
 */
export const HUB_SAFETY_NET_POLL_MS = 60_000;
